
import IAction from '../../models/IAction';
import ApiKeyModel from '../models/ApiKeyModel';
import { Reducer } from 'redux';
import baseReducer from '../../utilities/BaseReducer';
import ApiKeyActions from '../actions/apiKeysAction';
import ApiKeyListModel from '../models/ApiKeyListModel';

  export interface IApiKeyState {
    apiKeyList: ApiKeyListModel[];
    apiKey: ApiKeyModel;
    deleted: string;
  }
  
  const initialState = {
    apiKeyList: [],
    apiKey: new ApiKeyModel({}),
    deleted: '',
  };
  
  export const apiKeyReducer: Reducer = baseReducer(initialState, {
    [ApiKeyActions.REQUEST_GET_API_KEY_LIST_FINISHED]: (state: IApiKeyState, action: IAction<ApiKeyModel[]>):IApiKeyState => {
      return { 
        ...state,
        apiKeyList: action.payload!
      };
    },
    [ApiKeyActions.REQUEST_POST_API_KEY_FINISHED]: (state: IApiKeyState, action: IAction<ApiKeyModel>): IApiKeyState => {
        return { 
          ...state,
          apiKey: action.payload!,
        };
    },
    [ApiKeyActions.REQUEST_DELETE_API_KEY_FINISHED]: (state: IApiKeyState, action: IAction<string>):IApiKeyState => {
      return { 
        ...state,
        deleted: action.payload!
      };
    },
  });
